// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2Nm8C","additionalInfo":"AgreementModal_additionalInfo__2nsU5"};